import React, {useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import {HomeNoticeItem} from "../../common/Notice/HomeNoticeItem";

const Wrapper = styled.div`
    width: 577px;
    display: flex;
    flex-direction: column;
    margin-right: 24px;
`;
const TitleBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
`;

const Title = styled.div`
    display: flex;
    flex-direction: row;
`;

const GreenTitle = styled.span`
    color: ${props => props.theme.color.green_100};
    font-size: 20px;
    font-weight: bold;
    margin-right: 8px;
`;

const BlackTitle = styled.span`
    color: ${props => props.theme.color.dark_100};
    font-size: 20px;
    font-weight: bold;
`;

const ExtraWrapper = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const ExtraText = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.theme.color.dark_200};
    margin-right: 2px;

    &:hover {
        text-decoration: underline;
    }
`;
const ContentBox = styled.div`
    border: 1px solid ${props => props.theme.color.default_border_color};
    background-color: ${props => props.theme.color.site_main_color};
    border-radius: 10px;
    padding: 15px;
`;
const SplitLine = styled.div`
    height: 1px;
    background-color: ${props => props.theme.color.gray_200};
    width: 100%;
    margin: 8px 0;
`;
const HomeNoticeBoard = ({title, list, onClickMore}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const listMemo = useMemo(() => {
        try {
            if (Array.isArray(list)) {
                return list;
            }
            return [];
        } catch (e) {
            return [];
        }
    }, [list]);

    return (
        <Wrapper>
            <TitleBox>
                <Title>
                    <GreenTitle>{title}</GreenTitle>
                    <BlackTitle>{t('notice.title')}</BlackTitle>
                </Title>
                <ExtraWrapper onClick={onClickMore}>
                    <ExtraText>{t("summoner.moreChamp")}</ExtraText>
                    <img src={`${theme.icon.path}/icn_expand_arrow_m.svg`} width={8} height={8} alt={''}/>
                </ExtraWrapper>
            </TitleBox>
            <ContentBox>
                {listMemo.map((data, index) => {
                    return (
                        <>
                            {index !== 0 && <SplitLine/>}
                            <HomeNoticeItem title={data.title} time={data.datetime} url={data.url} imgUrl={data.img_url}
                                            key={index} subTitle={data.sub_title}/>
                        </>
                    )
                })}
            </ContentBox>
        </Wrapper>
    );
};


export default HomeNoticeBoard;